import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=50705ea6&"
import script from "./HeaderBar.vue?vue&type=script&lang=ts&"
export * from "./HeaderBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports